<div
  onclick="fileInput.click()"
  class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-primary-500 transition-colors"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
>
  <div class="flex flex-col items-center gap-4">
    <i class="material-symbols-outlined text-blue-500 !text-4xl">
      {{ icon() }}
    </i>

    <div class="space-y-2 w-full">
      @if (!selectedFile()) {
        <p class="text-sm hover:text-black-600 text-black-600">
          {{ label() }}
          <span class="text-primary-500 hover:text-primary-900 font-black"
            >procurar</span
          >
        </p>
        <input
          type="file"
          class="hidden"
          [accept]="acceptedFileTypes()"
          (change)="onFileSelected($event)"
          #fileInput
          id="fileInput"
        />
      } @else {
        <div class="w-full">
          <div class="flex items-center gap-2 mb-2">
            <i [class]="getFileIcon(selectedFile()) + ' text-primary-500'"></i>
            <span class="text-sm text-gray-600">{{
              selectedFile()?.name
            }}</span>
            <span class="text-xs text-gray-500 ml-auto">{{
              formatFileSize(selectedFile()?.size || 0)
            }}</span>
            <button
              class="text-gray-400 hover:text-gray-600 ml-2"
              (click)="clearFile($event)"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-1">
            <div
              class="bg-primary-500 h-1 rounded-full"
              [style.width.%]="uploadProgress()"
            ></div>
          </div>
        </div>
      }
    </div>

    <div class="text-xs text-gray-500">
      <p>Arquivo máximo de {{ maxSize() }}</p>
      <p>Formato recomendado {{ recommendedSize() }}</p>
    </div>
  </div>
</div>

<p class="text-xs text-gray-500">Arquivos suportados: .jpg, .png</p>
